<template>
  <div>
    <div class="all_logo_title">
      <div class="w1100 clearfix">
        <div class="logo">
          <a href=""><img src="static/images/logo.jpg" alt="" /></a>
        </div>
      </div>
    </div>
    <div class="all_nav_out">
      <div class="w1100">
        <ul id="nav" class="nav flex flex-pack-justify">
          <li class="nLi">
            <h3>
              <router-link :to="{ name: 'home' }" tag="a">网站首页</router-link>
            </h3>
          </li>
          <li class="nLi">
            <h3><a @click="currclick()">平台课程</a></h3>
          </li>
          <li class="nLi">
            <h3><a @click="gkselect('中心概况')">中心概况</a></h3>
          </li>
          <li class="nLi">
            <h3><a @click="typeclick('教师团队')">教学师资</a></h3>
          </li>
          <li class="nLi">
            <h3><a @click="typeclick('学术动态')">学术动态</a></h3>
          </li>
          <li class="nLi">
            <h3><a @click="typeclick('通知公告')">通知公告</a></h3>
          </li>
          <li class="nLi">
            <h3><a @click="typeclick('学院新闻')">学院新闻</a></h3>
          </li>
          <li class="nLi">
            <h3><a @click="typeclick('特色创新')">特色创新</a></h3>
          </li>
          <li class="nLi">
            <h3><a @click="typeclick('成果展示')">成果展示</a></h3>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { jquery } from "jquery";
import "../../../static/js/public.js";

import "../../../static/styles/reset.css";
import "../../../static/styles/common.css";
// import "../../../static/styles/iconfont.css";
import "../../../static/styles/style.css?v=0.01";

import Swiper from "swiper";
export default {
  mounted() {
    new Swiper(".banner-container", {
      autoplay: true,
      loop: true,
      navigation: {
        nextEl: ".banner-button-next",
        prevEl: ".banner-button-prev",
      },
    });

    // var nav = $(".cd-main-header"); //得到导航对象
    // var win = $(window); //得到窗口对象
    // var sc = $(document); //得到document文档对象。
    // win.scroll(function() {
    //   if (sc.scrollTop() >= 60) {
    //     nav.addClass("active");
    //     // $(".navTmp").fadeIn();
    //   } else {
    //     nav.removeClass("active");
    //     // $(".navTmp").fadeOut();
    //   }
    // });
  },
  methods: {
    menuclick(type) {
      // console.log(type);
      this.$router.push({
        name: "newslist",
      });
    },
    currclick() {
      let routeData = this.$router.resolve({
        path: "curriculum",
      });
      location.href = routeData.href;
    },
    typeclick(type) {
      localStorage.setItem("newstype", type);
      let routeData = this.$router.resolve({
        path: "ls",
      });
      location.href = routeData.href;
    },
    gkselect() {
      //type和name：分类
      //start：从第几条开始
      //num：查询数量
      //rec:是否推荐：0不推荐，1推荐
      let data = [
        {
          type: "zxgk",
          name: "zxgk",
          start: 0,
          num: 1,
          rec: 1,
        },
      ];
      var posturl =
        this.config.baseUrl.pro + "/Base_News/ApiIndexLoadBase_News";
      axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域2
          data: data,
        })
        .then((resp) => {
          if (resp.status === 200) {
            //这里进行赋值
            var list = resp.data.result;
            for (var i = 0; i < list.length; i++) {
              if (list[i].newslist.length > 0) {
                if (list[i].name === "zxgk") {
                  if (list[i].newslist.length > 0) {
                    // this.zxgklist = list[i].newslist[0];
                    console.log(list[i].newslist);
                    let routeData = this.$router.resolve({
                      path: "details",
                      query: { id: list[i].newslist[0].id },
                    });
                    window.open(routeData.href, "_blank");
                  }
                }
              }
            }
          }
        })
        .catch((err) => {
          this.$Message.info("数据请求失败");
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/webTop/webxxTopMenu.vue